import React, { createContext, useContext, useState } from 'react';

const OrderContext = createContext(null);

export const useOrder = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error('useOrder must be used within an OrderProvider');
  }
  return context;
};

export const OrderProvider = ({ children }) => {
  const [orderState, setOrderState] = useState({
    currentStep: 0, // 0: not started, 1: services, 2: translation summary, 3: payment
    quoteDetails: null,
    orderData: null,
    servicesCompleted: false,
    translationSummaryCompleted: false,
  });

  // Set the current step and mark it as completed
  const setCurrentStep = (step) => {
    setOrderState(prev => ({
      ...prev,
      currentStep: step,
      ...(step === 1 && { servicesCompleted: true }),
      ...(step === 2 && { translationSummaryCompleted: true }),
    }));
  };

  // Store quote details after services step
  const setQuoteDetails = (details) => {
    setOrderState(prev => ({
      ...prev,
      quoteDetails: details,
      servicesCompleted: true,
      currentStep: Math.max(prev.currentStep, 1)
    }));
  };

  // Store order data after translation summary step
  const setOrderData = (data) => {
    setOrderState(prev => ({
      ...prev,
      orderData: data,
      translationSummaryCompleted: true,
      currentStep: Math.max(prev.currentStep, 2)
    }));
  };

  // Reset the order state
  const resetOrder = () => {
    setOrderState({
      currentStep: 0,
      quoteDetails: null,
      orderData: null,
      servicesCompleted: false,
      translationSummaryCompleted: false,
    });
  };

  const value = {
    orderState,
    setCurrentStep,
    setQuoteDetails,
    setOrderData,
    resetOrder
  };

  return <OrderContext.Provider value={value}>{children}</OrderContext.Provider>;
}; 